import React from 'react';
import { Card, Row, Col, Form, Switch, InputNumber, Select, Divider, Typography, Tooltip } from 'antd';
import { CompanySettings } from '../../../../types/company.types';
import { InfoCircleOutlined, MessageOutlined, ClockCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { Option } = Select;

interface SmsSettingsFormProps {
  form: ReturnType<typeof Form.useForm>[0];
  settings: CompanySettings;
  loading: boolean;
}

const SmsSettingsForm: React.FC<SmsSettingsFormProps> = ({ form, settings, loading }) => (
  <Card className="setting-card">
    {/* <div style={{ marginBottom: 24 }}>
      <Title level={4} style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
        <MessageOutlined style={{ color: '#1890ff' }} />
        SMS Bildirim Ayarları
      </Title>
    </div> */}

    {/* Temel SMS Bildirimleri */}
    <Row gutter={[24, 16]}>
      <Col xs={24} sm={12} md={6}>
        <Form.Item
          label={
            <span>
              İzin Bildirimleri
              <Tooltip title="İzin talepleri onaylandığında veya reddedildiğinde SMS gönderilir">
                <InfoCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
              </Tooltip>
            </span>
          }
          name="sendSMSLeave"
          valuePropName="checked"
          initialValue={settings.sendSMSLeave}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Form.Item
          label={
            <span>
              Talep Bildirimleri
              <Tooltip title="Destek talepleri oluşturulduğunda veya yanıtlandığında SMS gönderilir">
                <InfoCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
              </Tooltip>
            </span>
          }
          name="sendSMSTicket"
          valuePropName="checked"
          initialValue={settings.sendSMSTicket}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Form.Item
          label={
            <span>
              Mazeret Bildirimleri
              <Tooltip title="Mazeret bildirimleri onaylandığında veya reddedildiğinde SMS gönderilir">
                <InfoCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
              </Tooltip>
            </span>
          }
          name="sendSMSExcuse"
          valuePropName="checked"
          initialValue={settings.sendSMSExcuse}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Form.Item
          label={
            <span>
              Mola Bildirimleri
              <Tooltip title="Mola aşımları ve uyarıları için SMS gönderilir">
                <InfoCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
              </Tooltip>
            </span>
          }
          name="sendSMSBreak"
          valuePropName="checked"
          initialValue={settings.sendSMSBreak}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
    </Row>
  </Card>
);

export default SmsSettingsForm;
